<template>
    <AdminAccountList :pk="pk" :lockedFilters="lockedFilters" :userTypeFilterOptions="userTypeFilterOptions">
    </AdminAccountList>
</template>


<script>
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import UserTypeMixin from "@/helpers/Mixins/UserTypeMixin";
import AdminAccountList from '@/views/admin/accounts/AdminAccountList.vue';

export default {
    name: "MixedAccountList",
    props: {},
    components: {
        AdminAccountList,
    },
    mixins: [UserTypeMixin, FilterQueryMixin],

    data() {
        return {
            pk: "MAL-",
        };
    },

    mounted() { },

    methods: {},

    computed: {
        routeBasedUserTypes() {
            var routeTypeFilterMapping = {
                "Accounts": this.notCustomerUserTypes.map(x => x.id),
                "AAccounts": [1],
                "TAccounts": [2],
                "SCAccounts": [3],
                "PAccounts": [5],
                "CAccounts": this.customerUserTypes.map(x => x.id),
            }
            var usertypearr = routeTypeFilterMapping[this.$route.name] ?? null;
            return usertypearr;
        },

        lockedFilters() {
            var filters = {};
            if (!this.userTypeFilterFromDropdown || this.userTypeFilterFromDropdown.length == 0) {
                filters.UserTypeIdList = this.routeBasedUserTypes;
            }
            return filters;
        },

        userTypeFilterOptions() {
            return [5];
        },

        userTypeFilterFromDropdown() {
            return this.getQueryParam("filter-usertype", []);
        },
        /*
        userTypeFilterFromDropdown: {
            get() {
                var it = this.getQueryParam("filter-usertype", []);
                if (it.length == 0) { return this.routeBasedUserTypes; }
                else { return it; }
            },
            set(update) {
                var byRoute = this.getUserTypeFilterFromRouteName(this.$route.name);
                if (update != byRoute) {
                    if (this.$route.name != 'Accounts') {
                        this.$router.replace({ name: 'Accounts', params: { ...this.$route.params }, query: { ...this.$route.query } });
                    }
                    this.setQueryParam("filter-usertype", update);
                }
            },
        },
        */
    },

    watch: {
        userTypeFilterFromDropdown: function (update) {
            //console.log("userTypeFilterFromDropdown", update);
            var byRoute = this.routeBasedUserTypes;
            if (update && update[0] && update != byRoute) {
                if (this.$route.name != 'Accounts') {
                    this.$router.replace({ name: 'Accounts', params: { ...this.$route.params }, query: { ...this.$route.query } });
                }
            }
        },
    },
};
</script>


<style lang='scss'></style>